import { render, staticRenderFns } from "./module-page.vue?vue&type=template&id=053bebeb&scoped=true"
import script from "./module-page.vue?vue&type=script&lang=js"
export * from "./module-page.vue?vue&type=script&lang=js"
import style0 from "./module-page.vue?vue&type=style&index=0&id=053bebeb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053bebeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053bebeb')) {
      api.createRecord('053bebeb', component.options)
    } else {
      api.reload('053bebeb', component.options)
    }
    module.hot.accept("./module-page.vue?vue&type=template&id=053bebeb&scoped=true", function () {
      api.rerender('053bebeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pageconfig/components/module-page.vue"
export default component.exports